export default __webpack_public_path__ + "static/media/Prison-3D-Model-05.01ef803e.jpg";